module.exports = __webpack_public_path__ + "media/trail/rotate-left-green-32a173c1.svg";